import { CircularProgress } from "@mui/material"
import React, { Fragment, useState } from "react"
import ChoiceFilter from "../ChoiceFilter/ChoiceFilter"
import useStyles from "./useStyles"
import { useDispatch, useSelector } from "react-redux"
import {
  changeSearchClientNames,
  getAllSubscriptionsCommunication,
  // getAllSubsDelegationVE,
  changeSearchClientNamesSubscription,
  changeSearchUserNamesSubscription,
  setSearchEvStatus,
} from "../../redux/actions/eventanilla"
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined"
import ReportOutlinedIcon from "@mui/icons-material/ReportOutlined"

export default function FilterInput({ searchType }) {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const {
    clientNames,
    searchValueCUIT,
    searchStatus,
    searchClientName,
    clientNamesSubscription,
    searchClientNameSubscription,
    searchuserNameSubscription,
    userNamesSubscription,
    evStatus,
    searchEvStatus,
  } = useSelector((state) => state.eventanilla)
  const dispatch = useDispatch()

  let options, value

  switch (searchType) {
    case "subscription":
      options = clientNamesSubscription
      value = searchClientNameSubscription
      break
    case "delegationAcceptationUser":
      options = userNamesSubscription
      value = searchuserNameSubscription
      break
    case "evStatus":
      options = evStatus
      value = searchEvStatus || null
      break
    case "eventanilla":
    default:
      options = clientNames
      value = searchClientName
      break
  }

  const changeSelectValues = async (_, newValue) => {
    setLoading(true)

    try {
      const selectedValue = Array.isArray(newValue) ? newValue : []
      switch (searchType) {
        case "eventanilla":
          dispatch(changeSearchClientNames(newValue))
          await dispatch(
            getAllSubscriptionsCommunication(
              searchValueCUIT,
              selectedValue,
              searchStatus,
            ),
          )
          break
        case "subscription": {
          dispatch(changeSearchClientNamesSubscription(newValue))
          break
        }
        case "evStatus": {
          dispatch(setSearchEvStatus(newValue))
          break
        }
        case "delegationAcceptationUser": {
          dispatch(
            changeSearchUserNamesSubscription(
              selectedValue && selectedValue.length > 0
                ? [selectedValue.at(-1)]
                : [],
            ),
          )
          break
        }
        default:
          console.warn(
            `FilterInput: El searchType "${searchType}" no es válido.`,
          )
          break
      }
    } catch (error) {
      console.error("Error al realizar la búsqueda:", error)
    } finally {
      setLoading(false)
    }
  }

  const getPlaceholderText = (searchType) => {
    switch (searchType) {
      case "delegationAcceptationUser":
        return "Buscar por email"
      case "evStatus":
        return "Buscar por estado"
      case "subscription":
      case "eventanilla":
      default:
        return "Buscar por nombre"
    }
  }

  const getOption = (option) => {
    switch (option) {
      case "Cliente Adherido a e-ventanilla":
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <EmailOutlinedIcon sx={{ marginRight: 1, color: "#509b92ff" }} />
            <p className={classes.pColor} style={{ color: "#509b92ff" }}>
              {option}
            </p>
          </div>
        )
      case "Cliente no adherido a e-ventanilla":
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <ApartmentOutlinedIcon
              sx={{ marginRight: 1, color: "#b4ae40ff" }}
            />
            <p className={classes.pColor} style={{ color: "#b4ae40ff" }}>
              {option}
            </p>
          </div>
        )
      case "Cliente con observaciones":
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <ApartmentOutlinedIcon
              sx={{ marginRight: 1, color: "#15acb1ff" }}
            />
            <p className={classes.pColor} style={{ color: "#15acb1ff" }}>
              {option}
            </p>
          </div>
        )
      case "CUIT No cargado como cliente":
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <ReportOutlinedIcon sx={{ marginRight: 1, color: "#b25353ff" }} />
            <p className={classes.pColor} style={{ color: "#b25353ff" }}>
              {option}
            </p>
          </div>
        )
      default:
        return <p className={classes.p}>{option}</p>
    }
  }

  return (
    <Fragment>
      {loading && (
        <div className={classes.loading}>
          <CircularProgress className={classes.iconLoading} />
        </div>
      )}

      <div
        className={classes.containerChoiseFilter}
        style={{
          display: loading ? "none" : "block",
        }}
      >
        <ChoiceFilter
          options={options || []}
          value={value || []}
          onChange={changeSelectValues}
          placeholder={getPlaceholderText(searchType)}
          getOptionLabel={(option) => option}
          getOption={(option) => getOption(option)}
          multiple={searchType !== "evStatus"}
          disableClearable={searchType === "evStatus" && !value}
          hideSelectedInInput={searchType === "evStatus"}
        />
      </div>
    </Fragment>
  )
}
